import { render, staticRenderFns } from "./live-dpd.vue?vue&type=template&id=521779ce&"
import script from "./live-dpd.vue?vue&type=script&lang=js&"
export * from "./live-dpd.vue?vue&type=script&lang=js&"
import style0 from "./live-dpd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "live-dpd.vue"
export default component.exports